export default __webpack_public_path__ + "static/media/arrow.0922d7d6.svg";